[{"startTime":"","endTime":"","count":"","luckyDrawConditionEntities":[{"type":"","typeValue":"","conditionsProductType":""}]}]
<template>
  <div class="wrapper">
    <el-card class="box-card" >
      <div class="text" v-for="(card,index) in update.col.data">
        <div slot="header" class="clearfix titleCon">
          <div class="titleName">条件组 {{index+1}}</div>
          <div v-if="!readonly" class="btn-list">
            <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
            <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
          </div>
        </div>
        <div class="item">
          <div class="item-list">
            <em>用户在</em>
            <el-date-picker :required="true" :disabled="readonly"   v-model="card.startTime"  type="datetime" :value-format="'yyyy-MM-dd HH:mm:ss'" :placeholder="'开始时间'"></el-date-picker>
            <em>至</em>
            <el-date-picker :required="true" :disabled="readonly"   v-model="card.endTime"  type="datetime" :value-format="'yyyy-MM-dd HH:mm:ss'" :placeholder="'结束时间'"></el-date-picker>
          </div>
          <!--条件列表-->
          <div class="item-list">
            <condition :update="update" :productionList="productionList" :luckyDrawConditionEntities="card.luckyDrawConditionEntities"></condition>
          </div>
          <div class="item-list">
            <em>可获得</em>
            <el-input controls-position="right" style="width: 15%" v-model="card.count" :required="true" :disabled="readonly"></el-input>
            <em>次抽奖机会</em>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  require('@/views/crs36/luckyDraw/template.css')
  import condition from '@/views/crs36/luckyDraw/condition.vue'
  import Url from "@/views/crs36/util/url";
  import Qs from 'qs'
  export default {
    name: 'conditionsGroup',
    props:["update"],
    components: {
      condition
    },
    created() {
      if(this.productionList.length == 0){
        this.axios.post(Url.luckyDraw.lucky.getProductionList, Qs.stringify({})).then(res => {
          if (res.code == 0){
            const arr = res.result;
            for (let i in arr) {
              this.productionList.push(arr[i]);
            }
          }
        })
      }
    },
    methods: {
        addReward(){
            this.update.col.data.push({"startTime":"","endTime":"","count":"","luckyDrawConditionEntities":[{"type":"","typeValue":0,"conditionsProductType":""}]});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        }
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.isBy == 1)?true:false;
        }
    },
    data () {
      return {
        productionList: [],
      }
    }
  }
</script>
